const CAP = {
  title: "Capítulo 5 — Frase mnemotécnica (Seed Phrase)",
  sections: [
    {
      heading: "La frase mnemotécnica: tu verdadera llave",
      text: [
        "Después de crear una billetera, el elemento más importante con el que tratamos directamente no es la llave privada, sino la **frase mnemotécnica** o **seed phrase**.",
        "La frase mnemotécnica es una representación más sencilla de recordar de tu clave maestra y está respaldada por estándares ampliamente aceptados en el ecosistema.",
        "Mientras tengas tu seed phrase, puedes **restaurar tu billetera en otro dispositivo o aplicación compatible**. Si la pierdes, pierdes el acceso; si alguien más la obtiene, también obtiene control total sobre tus fondos."
      ]
    },
    {
      heading: "Estándares y cantidad de palabras",
      text: [
        "Las frases mnemotécnicas modernas siguen estándares como **BIP-39**, utilizados por la mayoría de billeteras serias.",
        "Usualmente constan de **12 palabras** en inglés, aunque también pueden tener otros múltiplos de 3: **15, 18, 21 o 24 palabras**.",
        "En la práctica, menos de 12 palabras se considera inseguro y más de 24 no aporta beneficios reales, solo complica su manejo. Por eso los estándares se quedan entre 12 y 24 palabras."
      ],
      list: [
        "Común en el ecosistema: **12 palabras** (suficiente para la mayoría de los casos).",
        "Opciones avanzadas: **15/18/21/24 palabras** para configuraciones más exigentes.",
        "Hardware wallets como **Ledger** suelen generar frases de **24 palabras** por defecto."
      ]
    },
    {
      heading: "Idiomas disponibles",
      text: [
        "Además del inglés, BIP-39 soporta otros idiomas como chino, japonés, coreano, español y más.",
        "Cada idioma tiene su propia lista oficial de **2048 palabras estandarizadas**. Eso significa que tu billetera no se inventa palabras al azar: las elige de esa lista predefinida."
      ],
      pre: [
        "Listas oficiales: https://github.com/bitcoin/bips/blob/master/bip-0039/bip-0039-wordlists.md"
      ]
    },
    {
      heading: "Tu frase mnemotécnica es vulnerable",
      text: [
        "Durante la creación de la billetera, tu **seed phrase está expuesta en pantalla**. Este es uno de los momentos de mayor riesgo de todo el proceso.",
        "Debes asegurarte de que no haya personas mirando, cámaras, spyware, pantallas compartidas o cualquier cosa que pueda capturar tu frase. Si alguien la ve o la copia, puede **restaurar tu billetera desde cualquier parte del mundo**."
      ],
      list: [
        "**Nunca tomes fotos de tu seed phrase.**",
        "**Nunca la guardes en notas del teléfono o en capturas de pantalla.**",
        "**Nunca la escribas en una computadora conectada a Internet.**",
        "**No la compartas con nadie, aunque digan ser ‘soporte oficial’ o ‘equipo técnico’.**"
      ]
    },
    {
      heading: "Asegúrate de que la frase sea aleatoria",
      text: [
        "Normalmente, las billeteras conocidas generan frases suficientemente aleatorias utilizando fuentes de entropía internas (hardware, sistema operativo, etc.).",
        "Aun así, siempre debes ser cauteloso: es imposible estar 100% seguro de que una billetera no tiene un error o manipulación interna, por eso confiamos en proyectos abiertos, auditados y con buena reputación.",
        "Un punto importante: **no inventes tú la frase**. No uses frases ‘bonitas’, canciones, citas o palabras que tú elijas. La seguridad viene de la aleatoriedad real, no de lo fácil de recordar.",
        "Desarrollar hábitos de verificación y prudencia (usar software reputado, fuentes oficiales, versiones actualizadas) te dará una enorme ventaja en seguridad."
      ]
    },
    {
      heading: "Crear una frase para una cold wallet",
      text: [
        "Si la billetera será usada como **cold wallet** (billetera fría para ahorro a largo plazo), una práctica muy recomendable es **desconectar el dispositivo de Internet** mientras generas la seed phrase.",
        "Crear la frase completamente fuera de línea es una de las medidas más seguras que existen, porque reduce al mínimo las posibilidades de que malware o scripts ocultos la capturen.",
        "Después de generarla, **escríbela en papel o en placas metálicas** con buena letra, revisando dos o tres veces que todas las palabras estén correctas y en el orden indicado.",
        "Recuerda: **desconectarse de Internet siempre ayuda** cuando se trata de proteger la raíz de tu patrimonio digital."
      ]
    }
  ]
};

export default CAP;
